module.exports = __webpack_public_path__ + "static/media/family-vacation-mob.d9d80be3.jpg";